import UpgradeSelectionBoxes from './UpgradeSelectionBoxes';

export default UpgradeSelectionBoxes;
